/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { feePlansListFeePlans } from "../../funcs/feePlansListFeePlans.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListFeePlansRequest$inboundSchema,
};

export const tool$feePlansListFeePlans: ToolDefinition<typeof args> = {
  name: "fee-plans-list-fee-plans",
  description:
    `List all fee plans available for use by an account. This is intended to be used by an account when 
selecting a fee plan to apply to a connected account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/profile.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await feePlansListFeePlans(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
